import axios from "axios";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";
import DataTable from "../components/DataTable";

const ListarRegionales = () => {
  const [regionales, setRegionales] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ✅ Eliminar regional (misma lógica visual que ListaInstructores)
  const deleteRegional = async (id) => {
    try {
      Swal.fire({
        title: "¿Está seguro?",
        text: "¡No podrá revertir este proceso!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await axios.delete(`/api/regionales/delete/${id}`);
          await getData();
          Swal.fire({
            icon: "success",
            title: data.message || "Regional eliminada",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    } catch (error) {
      console.error("Error al eliminar:", error.message);
      Swal.fire("Error", "No se pudo eliminar la regional", "error");
    }
  };

  // ✅ Traer datos (estilo ListaInstructores)
  const getData = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await axios.get("/api/regionales/listall/");

      if (data?.ok && Array.isArray(data.regionales)) {
        const regionalesOrdenadas = data.regionales
          .sort((a, b) => (a?.nombreRegional || "").localeCompare(b?.nombreRegional || ""))
          .map((regional) => ({
            ...regional,
            funciones: (
              <div className="d-flex gap-2 flex-wrap justify-content-end">
                {/* Editar (amarillo) */}
                <button
                  className="btn btn-warning btn-sm d-inline-flex align-items-center justify-content-center"
                  style={{ width: 34, height: 34 }}
                  onClick={() => navigate(`/institucional/regional/edit/${regional._id}`)}
                  title="Editar Regional"
                  type="button"
                >
                  <i className="fa-solid fa-pen-to-square"></i>
                </button>

                {/* Eliminar (rojo) */}
                <button
                  className="btn btn-danger btn-sm d-inline-flex align-items-center justify-content-center"
                  style={{ width: 34, height: 34 }}
                  onClick={() => deleteRegional(regional._id)}
                  title="Eliminar Regional"
                  type="button"
                >
                  <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            ),
          }));

        setRegionales(regionalesOrdenadas);
      } else {
        setRegionales([]);
      }
    } catch (error) {
      console.error("Error al obtener regionales:", error.message);
      Swal.fire("Error", "No se pudieron cargar las regionales.", "error");
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [navigate]);

  useEffect(() => {
    getData();
  }, [getData]);

  const columns = useMemo(
    () => [
      { Header: "Código", accessor: "codRegional" },
      { Header: "Regional", accessor: "nombreRegional" },
      { accessor: "funciones" },
    ],
    []
  );

  return (
    <div>
      <div className="container-fluid px-2 px-md-4">
        <div className="bg-white border rounded-4 shadow-sm overflow-hidden">
          {/* Header */}
          <div className="px-3 px-md-4 py-3 border-bottom bg-white">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
              <div>
                <h5 className="mt-2 mb-1 fw-semibold">Regionales</h5>
                <small className="text-secondary">
                  Gestión institucional y administración de regionales.
                </small>
              </div>

              <div className="d-flex gap-2 flex-wrap">
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => getData()}
                  title="Actualizar"
                  disabled={loading}
                >
                  <i className={`fa-solid ${loading ? "fa-spinner fa-spin" : "fa-rotate"} me-2`}></i>
                  Actualizar
                </button>

                <button
                  className="btn btn-dark"
                  type="button"
                  onClick={() => navigate("/institucional/regional/nuevo")}
                  title="Crear Regional"
                >
                  <i className="fa-solid fa-plus me-2"></i>
                  Nuevo
                </button>
              </div>
            </div>
          </div>

          {/* Body */}
          <div>
            {loading ? (
              <div className="text-center text-secondary py-5">
                <div className="spinner-border" role="status" aria-hidden="true"></div>
                <div className="mt-3">Cargando regionales…</div>
              </div>
            ) : Array.isArray(regionales) && regionales.length > 0 ? (
              <div className="overflow-hidden">
                <DataTable columns={columns} data={regionales} />
              </div>
            ) : (
              <div className="text-center text-secondary py-5">
                <div className="display-6 mb-2">🐾</div>
                <div className="fw-semibold">No hay regionales registradas</div>
                <div className="small mb-3">Crea el primer registro para iniciar la gestión.</div>
                <button
                  className="btn btn-dark"
                  type="button"
                  onClick={() => navigate("/institucional/regional/nuevo")}
                >
                  <i className="fa-solid fa-plus me-2"></i>
                  Crear regional
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListarRegionales;